let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TCvt")).then(() => parcelRequire('8gRGg'));